
      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hALax", function(module, exports) {

var $joIhc = parcelRequire("joIhc");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $joIhc.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});
parcelRegister("joIhc", function(module, exports) {

var $3Pfvq = parcelRequire("3Pfvq");
/** Detect free variable `self`. */ var $e1f29a94f3202822$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $e1f29a94f3202822$var$root = $3Pfvq || $e1f29a94f3202822$var$freeSelf || Function("return this")();
module.exports = $e1f29a94f3202822$var$root;

});
parcelRegister("3Pfvq", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $2c9229a3504a6578$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $2c9229a3504a6578$var$freeGlobal;

});



parcelRegister("6FHvm", function(module, exports) {

var $joIhc = parcelRequire("joIhc");

var $fVIdZ = parcelRequire("fVIdZ");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $joIhc.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $fVIdZ;
module.exports = isBuffer;

});
parcelRegister("fVIdZ", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $b98e7bf473aad82b$var$stubFalse() {
    return false;
}
module.exports = $b98e7bf473aad82b$var$stubFalse;

});


parcelRegister("9f4Zz", function(module, exports) {

var $3Pfvq = parcelRequire("3Pfvq");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $3Pfvq.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

var $92e55a48894507f5$export$dd412b56f1e4d8aa;
"use strict";
$92e55a48894507f5$export$dd412b56f1e4d8aa = $92e55a48894507f5$var$addDays;
var $10272ab2063f75db$export$e67a095c620b86fe;
"use strict";
$10272ab2063f75db$export$e67a095c620b86fe = $10272ab2063f75db$var$toDate;
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $10272ab2063f75db$var$toDate(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}


var $637d5e857124f8fb$export$ead8a1812b171991;
"use strict";
$637d5e857124f8fb$export$ead8a1812b171991 = $637d5e857124f8fb$var$constructFrom;
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */ function $637d5e857124f8fb$var$constructFrom(date, value) {
    if (date instanceof Date) return new date.constructor(value);
    else return new Date(value);
}


/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */ function $92e55a48894507f5$var$addDays(date, amount) {
    const _date = (0, $10272ab2063f75db$export$e67a095c620b86fe)(date);
    if (isNaN(amount)) return (0, $637d5e857124f8fb$export$ead8a1812b171991)(date, NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}


var $6a37a3bc1281828d$export$3d83eec43f4ea476;
"use strict";
$6a37a3bc1281828d$export$3d83eec43f4ea476 = $6a37a3bc1281828d$var$addYears;
var $ab15bc493449998c$export$17c93e242b2d3a22;
"use strict";
$ab15bc493449998c$export$17c93e242b2d3a22 = $ab15bc493449998c$var$addMonths;


/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of months to be added.
 *
 * @returns The new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 *
 * // Add one month to 30 January 2023:
 * const result = addMonths(new Date(2023, 0, 30), 1)
 * //=> Tue Feb 28 2023 00:00:00
 */ function $ab15bc493449998c$var$addMonths(date, amount) {
    const _date = (0, $10272ab2063f75db$export$e67a095c620b86fe)(date);
    if (isNaN(amount)) return (0, $637d5e857124f8fb$export$ead8a1812b171991)(date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $637d5e857124f8fb$export$ead8a1812b171991)(date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}


/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param amount - The amount of years to be added.
 *
 * @returns The new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */ function $6a37a3bc1281828d$var$addYears(date, amount) {
    return (0, $ab15bc493449998c$export$17c93e242b2d3a22)(date, amount * 12);
}


var $bb157686983b9d37$export$d3b42cd8452deec;
"use strict";
$bb157686983b9d37$export$d3b42cd8452deec = $bb157686983b9d37$var$getDayOfYear;
var $3520458f421ce5c7$export$4a02e9c37dab4871;
"use strict";
$3520458f421ce5c7$export$4a02e9c37dab4871 = $3520458f421ce5c7$var$differenceInCalendarDays;
var $9e78331521a08d61$export$7271e9e3478110d1;
var $9e78331521a08d61$export$34804a017b31e2fe;
var $9e78331521a08d61$export$be1dccf2de902d31;
var $9e78331521a08d61$export$8e6600bbdee7dabb;
var $9e78331521a08d61$export$a77c1a7ebebe2a5a;
var $9e78331521a08d61$export$698aec755e92c695;
var $9e78331521a08d61$export$815a9362476d2fe3;
var $9e78331521a08d61$export$4db7641526e3241f;
var $9e78331521a08d61$export$80d7e435f744f319;
var $9e78331521a08d61$export$3c58128db900d44e;
var $9e78331521a08d61$export$3633035e63cee86a;
var $9e78331521a08d61$export$ab7da2ccd1075c38;
var $9e78331521a08d61$export$f2f5ae5a8e2d8f9f;
var $9e78331521a08d61$export$2423174df8cd3cd2;
var $9e78331521a08d61$export$4dec998e48f9c246;
var $9e78331521a08d61$export$4fad13613e88edc8;
var $9e78331521a08d61$export$397c2d5776aa9055;
var $9e78331521a08d61$export$91246f0b9bd9beff;
var $9e78331521a08d61$export$7f72910d6dfd237a;
var $9e78331521a08d61$export$b76b1809a2898f9a;
var $9e78331521a08d61$export$81caae6e1cc7a622;
var $9e78331521a08d61$export$3913210603d8e9ae;
var $9e78331521a08d61$export$dfd9b671c89acc8e;
"use strict";
$9e78331521a08d61$export$7271e9e3478110d1 = $9e78331521a08d61$export$34804a017b31e2fe = $9e78331521a08d61$export$be1dccf2de902d31 = $9e78331521a08d61$export$8e6600bbdee7dabb = $9e78331521a08d61$export$a77c1a7ebebe2a5a = $9e78331521a08d61$export$698aec755e92c695 = $9e78331521a08d61$export$815a9362476d2fe3 = $9e78331521a08d61$export$4db7641526e3241f = $9e78331521a08d61$export$80d7e435f744f319 = $9e78331521a08d61$export$3c58128db900d44e = $9e78331521a08d61$export$3633035e63cee86a = $9e78331521a08d61$export$ab7da2ccd1075c38 = $9e78331521a08d61$export$f2f5ae5a8e2d8f9f = $9e78331521a08d61$export$2423174df8cd3cd2 = $9e78331521a08d61$export$4dec998e48f9c246 = $9e78331521a08d61$export$4fad13613e88edc8 = $9e78331521a08d61$export$397c2d5776aa9055 = $9e78331521a08d61$export$91246f0b9bd9beff = $9e78331521a08d61$export$7f72910d6dfd237a = $9e78331521a08d61$export$b76b1809a2898f9a = $9e78331521a08d61$export$81caae6e1cc7a622 = $9e78331521a08d61$export$3913210603d8e9ae = $9e78331521a08d61$export$dfd9b671c89acc8e = void 0; /**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ 
/**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $9e78331521a08d61$var$daysInWeek = $9e78331521a08d61$export$dfd9b671c89acc8e = 7;
/**
 * @constant
 * @name daysInYear
 * @summary Days in 1 year.
 *
 * @description
 * How many days in a year.
 *
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 */ const $9e78331521a08d61$var$daysInYear = $9e78331521a08d61$export$3913210603d8e9ae = 365.2425;
/**
 * @constant
 * @name maxTime
 * @summary Maximum allowed time.
 *
 * @example
 * import { maxTime } from "date-fns/constants";
 *
 * const isValid = 8640000000000001 <= maxTime;
 * //=> false
 *
 * new Date(8640000000000001);
 * //=> Invalid Date
 */ const $9e78331521a08d61$var$maxTime = $9e78331521a08d61$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
/**
 * @constant
 * @name minTime
 * @summary Minimum allowed time.
 *
 * @example
 * import { minTime } from "date-fns/constants";
 *
 * const isValid = -8640000000000001 >= minTime;
 * //=> false
 *
 * new Date(-8640000000000001)
 * //=> Invalid Date
 */ const $9e78331521a08d61$var$minTime = $9e78331521a08d61$export$4dec998e48f9c246 = -$9e78331521a08d61$var$maxTime;
/**
 * @constant
 * @name millisecondsInWeek
 * @summary Milliseconds in 1 week.
 */ const $9e78331521a08d61$var$millisecondsInWeek = $9e78331521a08d61$export$4fad13613e88edc8 = 604800000;
/**
 * @constant
 * @name millisecondsInDay
 * @summary Milliseconds in 1 day.
 */ const $9e78331521a08d61$var$millisecondsInDay = $9e78331521a08d61$export$b76b1809a2898f9a = 86400000;
/**
 * @constant
 * @name millisecondsInMinute
 * @summary Milliseconds in 1 minute
 */ const $9e78331521a08d61$var$millisecondsInMinute = $9e78331521a08d61$export$91246f0b9bd9beff = 60000;
/**
 * @constant
 * @name millisecondsInHour
 * @summary Milliseconds in 1 hour
 */ const $9e78331521a08d61$var$millisecondsInHour = $9e78331521a08d61$export$7f72910d6dfd237a = 3600000;
/**
 * @constant
 * @name millisecondsInSecond
 * @summary Milliseconds in 1 second
 */ const $9e78331521a08d61$var$millisecondsInSecond = $9e78331521a08d61$export$397c2d5776aa9055 = 1000;
/**
 * @constant
 * @name minutesInYear
 * @summary Minutes in 1 year.
 */ const $9e78331521a08d61$var$minutesInYear = $9e78331521a08d61$export$3633035e63cee86a = 525600;
/**
 * @constant
 * @name minutesInMonth
 * @summary Minutes in 1 month.
 */ const $9e78331521a08d61$var$minutesInMonth = $9e78331521a08d61$export$ab7da2ccd1075c38 = 43200;
/**
 * @constant
 * @name minutesInDay
 * @summary Minutes in 1 day.
 */ const $9e78331521a08d61$var$minutesInDay = $9e78331521a08d61$export$2423174df8cd3cd2 = 1440;
/**
 * @constant
 * @name minutesInHour
 * @summary Minutes in 1 hour.
 */ const $9e78331521a08d61$var$minutesInHour = $9e78331521a08d61$export$f2f5ae5a8e2d8f9f = 60;
/**
 * @constant
 * @name monthsInQuarter
 * @summary Months in 1 quarter.
 */ const $9e78331521a08d61$var$monthsInQuarter = $9e78331521a08d61$export$3c58128db900d44e = 3;
/**
 * @constant
 * @name monthsInYear
 * @summary Months in 1 year.
 */ const $9e78331521a08d61$var$monthsInYear = $9e78331521a08d61$export$80d7e435f744f319 = 12;
/**
 * @constant
 * @name quartersInYear
 * @summary Quarters in 1 year
 */ const $9e78331521a08d61$var$quartersInYear = $9e78331521a08d61$export$4db7641526e3241f = 4;
/**
 * @constant
 * @name secondsInHour
 * @summary Seconds in 1 hour.
 */ const $9e78331521a08d61$var$secondsInHour = $9e78331521a08d61$export$698aec755e92c695 = 3600;
/**
 * @constant
 * @name secondsInMinute
 * @summary Seconds in 1 minute.
 */ const $9e78331521a08d61$var$secondsInMinute = $9e78331521a08d61$export$a77c1a7ebebe2a5a = 60;
/**
 * @constant
 * @name secondsInDay
 * @summary Seconds in 1 day.
 */ const $9e78331521a08d61$var$secondsInDay = $9e78331521a08d61$export$815a9362476d2fe3 = $9e78331521a08d61$var$secondsInHour * 24;
/**
 * @constant
 * @name secondsInWeek
 * @summary Seconds in 1 week.
 */ const $9e78331521a08d61$var$secondsInWeek = $9e78331521a08d61$export$34804a017b31e2fe = $9e78331521a08d61$var$secondsInDay * 7;
/**
 * @constant
 * @name secondsInYear
 * @summary Seconds in 1 year.
 */ const $9e78331521a08d61$var$secondsInYear = $9e78331521a08d61$export$7271e9e3478110d1 = $9e78331521a08d61$var$secondsInDay * $9e78331521a08d61$var$daysInYear;
/**
 * @constant
 * @name secondsInMonth
 * @summary Seconds in 1 month
 */ const $9e78331521a08d61$var$secondsInMonth = $9e78331521a08d61$export$8e6600bbdee7dabb = $9e78331521a08d61$var$secondsInYear / 12;
/**
 * @constant
 * @name secondsInQuarter
 * @summary Seconds in 1 quarter.
 */ const $9e78331521a08d61$var$secondsInQuarter = $9e78331521a08d61$export$be1dccf2de902d31 = $9e78331521a08d61$var$secondsInMonth * 3;


var $99fc98dcf05ff69b$export$63fa379ae8a9ba2;
"use strict";
$99fc98dcf05ff69b$export$63fa379ae8a9ba2 = $99fc98dcf05ff69b$var$startOfDay;

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */ function $99fc98dcf05ff69b$var$startOfDay(date) {
    const _date = (0, $10272ab2063f75db$export$e67a095c620b86fe)(date);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


var $93ae7974b0e0b5ae$export$113002b5eff6e430;
"use strict";
$93ae7974b0e0b5ae$export$113002b5eff6e430 = $93ae7974b0e0b5ae$var$getTimezoneOffsetInMilliseconds;

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $93ae7974b0e0b5ae$var$getTimezoneOffsetInMilliseconds(date) {
    const _date = (0, $10272ab2063f75db$export$e67a095c620b86fe)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}


/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */ function $3520458f421ce5c7$var$differenceInCalendarDays(dateLeft, dateRight) {
    const startOfDayLeft = (0, $99fc98dcf05ff69b$export$63fa379ae8a9ba2)(dateLeft);
    const startOfDayRight = (0, $99fc98dcf05ff69b$export$63fa379ae8a9ba2)(dateRight);
    const timestampLeft = +startOfDayLeft - (0, $93ae7974b0e0b5ae$export$113002b5eff6e430)(startOfDayLeft);
    const timestampRight = +startOfDayRight - (0, $93ae7974b0e0b5ae$export$113002b5eff6e430)(startOfDayRight);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((timestampLeft - timestampRight) / $9e78331521a08d61$export$b76b1809a2898f9a);
}


var $93b3cae1d0346277$export$f91e89d3d0406102;
"use strict";
$93b3cae1d0346277$export$f91e89d3d0406102 = $93b3cae1d0346277$var$startOfYear;


/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */ function $93b3cae1d0346277$var$startOfYear(date) {
    const cleanDate = (0, $10272ab2063f75db$export$e67a095c620b86fe)(date);
    const _date = (0, $637d5e857124f8fb$export$ead8a1812b171991)(date, 0);
    _date.setFullYear(cleanDate.getFullYear(), 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}



/**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */ function $bb157686983b9d37$var$getDayOfYear(date) {
    const _date = (0, $10272ab2063f75db$export$e67a095c620b86fe)(date);
    const diff = (0, $3520458f421ce5c7$export$4a02e9c37dab4871)(_date, (0, $93b3cae1d0346277$export$f91e89d3d0406102)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}


var $961776d6230cb8d4$export$2af590ffc7e7d7c5;
"use strict";
$961776d6230cb8d4$export$2af590ffc7e7d7c5 = $961776d6230cb8d4$var$setDayOfYear;

/**
 * @name setDayOfYear
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to be changed
 * @param dayOfYear - The day of the year of the new date
 *
 * @returns The new date with the day of the year set
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * const result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */ function $961776d6230cb8d4$var$setDayOfYear(date, dayOfYear) {
    const _date = (0, $10272ab2063f75db$export$e67a095c620b86fe)(date);
    _date.setMonth(0);
    _date.setDate(dayOfYear);
    return _date;
}


var $36df08523e631d65$export$86415ebf4eb36b8c;
"use strict";
$36df08523e631d65$export$86415ebf4eb36b8c = $36df08523e631d65$var$differenceInDays;


/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.trunc(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param dateLeft - The later date
 * @param dateRight - The earlier date
 *
 * @returns The number of full days according to the local timezone
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 *
 * @example
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
 * //=> 92
 */ function $36df08523e631d65$var$differenceInDays(dateLeft, dateRight) {
    const _dateLeft = (0, $10272ab2063f75db$export$e67a095c620b86fe)(dateLeft);
    const _dateRight = (0, $10272ab2063f75db$export$e67a095c620b86fe)(dateRight);
    const sign = $36df08523e631d65$var$compareLocalAsc(_dateLeft, _dateRight);
    const difference = Math.abs((0, $3520458f421ce5c7$export$4a02e9c37dab4871)(_dateLeft, _dateRight));
    _dateLeft.setDate(_dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastDayNotFull = Number($36df08523e631d65$var$compareLocalAsc(_dateLeft, _dateRight) === -sign);
    const result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $36df08523e631d65$var$compareLocalAsc(dateLeft, dateRight) {
    const diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}


var $4a775c5b3dcbb445$export$5c007e10c6929c95;
"use strict";
$4a775c5b3dcbb445$export$5c007e10c6929c95 = $4a775c5b3dcbb445$var$isBefore;

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date that should be before the other one to return true
 * @param dateToCompare - The date to compare with
 *
 * @returns The first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */ function $4a775c5b3dcbb445$var$isBefore(date, dateToCompare) {
    const _date = (0, $10272ab2063f75db$export$e67a095c620b86fe)(date);
    const _dateToCompare = (0, $10272ab2063f75db$export$e67a095c620b86fe)(dateToCompare);
    return +_date < +_dateToCompare;
}



var $1232e9c9fcb8c1ea$exports = {};
"use strict";
$1232e9c9fcb8c1ea$exports.format = $1232e9c9fcb8c1ea$exports.formatDate = $1232e9c9fcb8c1ea$var$format;
Object.defineProperty($1232e9c9fcb8c1ea$exports, "formatters", {
    enumerable: true,
    get: function() {
        return $74a92283fe8a9cad$export$fe98a034cfb96d55;
    }
});
Object.defineProperty($1232e9c9fcb8c1ea$exports, "longFormatters", {
    enumerable: true,
    get: function() {
        return $7b268c7137b61ea8$export$70cc8fd02856fd58;
    }
});
var $4a3b8322c1a23c85$exports = {};
"use strict";
Object.defineProperty($4a3b8322c1a23c85$exports, "defaultLocale", {
    enumerable: true,
    get: function() {
        return $bec673a8a764e47c$export$137380d9ce54f7f;
    }
});
var $bec673a8a764e47c$export$137380d9ce54f7f;
"use strict";
$bec673a8a764e47c$export$137380d9ce54f7f = void 0;
var $1f0453eadb8ad666$export$2c14ff85d6318973;
"use strict";
$1f0453eadb8ad666$export$2c14ff85d6318973 = void 0;
const $1f0453eadb8ad666$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $1f0453eadb8ad666$var$formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = $1f0453eadb8ad666$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
$1f0453eadb8ad666$export$2c14ff85d6318973 = $1f0453eadb8ad666$var$formatDistance;


var $ffdbba01a514217d$export$cbf60ecb96cbb82f;
"use strict";
$ffdbba01a514217d$export$cbf60ecb96cbb82f = void 0;
var $779c7ae29295a5ef$export$38e44e97ce4dbb7d;
"use strict";
$779c7ae29295a5ef$export$38e44e97ce4dbb7d = $779c7ae29295a5ef$var$buildFormatLongFn;
function $779c7ae29295a5ef$var$buildFormatLongFn(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


const $ffdbba01a514217d$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $ffdbba01a514217d$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $ffdbba01a514217d$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $ffdbba01a514217d$var$formatLong = $ffdbba01a514217d$export$cbf60ecb96cbb82f = {
    date: (0, $779c7ae29295a5ef$export$38e44e97ce4dbb7d)({
        formats: $ffdbba01a514217d$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $779c7ae29295a5ef$export$38e44e97ce4dbb7d)({
        formats: $ffdbba01a514217d$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $779c7ae29295a5ef$export$38e44e97ce4dbb7d)({
        formats: $ffdbba01a514217d$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


var $4e9842a07c0b25fa$export$8fbbfd65594f46a0;
"use strict";
$4e9842a07c0b25fa$export$8fbbfd65594f46a0 = void 0;
const $4e9842a07c0b25fa$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $4e9842a07c0b25fa$var$formatRelative = (token, _date, _baseDate, _options)=>$4e9842a07c0b25fa$var$formatRelativeLocale[token];
$4e9842a07c0b25fa$export$8fbbfd65594f46a0 = $4e9842a07c0b25fa$var$formatRelative;


var $ce5b2daca8dcbc64$export$b3bd0bc58e36cd63;
"use strict";
$ce5b2daca8dcbc64$export$b3bd0bc58e36cd63 = void 0;
var $5845acda737f9e30$export$63596d6ee8878b25;
"use strict";
$5845acda737f9e30$export$63596d6ee8878b25 = $5845acda737f9e30$var$buildLocalizeFn; /* eslint-disable no-unused-vars */ 
/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $5845acda737f9e30$var$buildLocalizeFn(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


const $ce5b2daca8dcbc64$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $ce5b2daca8dcbc64$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $ce5b2daca8dcbc64$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $ce5b2daca8dcbc64$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $ce5b2daca8dcbc64$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $ce5b2daca8dcbc64$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $ce5b2daca8dcbc64$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $ce5b2daca8dcbc64$var$localize = $ce5b2daca8dcbc64$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $ce5b2daca8dcbc64$var$ordinalNumber,
    era: (0, $5845acda737f9e30$export$63596d6ee8878b25)({
        values: $ce5b2daca8dcbc64$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $5845acda737f9e30$export$63596d6ee8878b25)({
        values: $ce5b2daca8dcbc64$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $5845acda737f9e30$export$63596d6ee8878b25)({
        values: $ce5b2daca8dcbc64$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $5845acda737f9e30$export$63596d6ee8878b25)({
        values: $ce5b2daca8dcbc64$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $5845acda737f9e30$export$63596d6ee8878b25)({
        values: $ce5b2daca8dcbc64$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $ce5b2daca8dcbc64$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


var $10a3d575eaf4b44f$export$4659b591c19bdf3d;
"use strict";
$10a3d575eaf4b44f$export$4659b591c19bdf3d = void 0;
var $60f1ebf50e69229e$export$1430a0f35710914d;
"use strict";
$60f1ebf50e69229e$export$1430a0f35710914d = $60f1ebf50e69229e$var$buildMatchFn;
function $60f1ebf50e69229e$var$buildMatchFn(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $60f1ebf50e69229e$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $60f1ebf50e69229e$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $60f1ebf50e69229e$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $60f1ebf50e69229e$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


var $e30cd69d0510cc67$export$fdaf2fd6d7edde95;
"use strict";
$e30cd69d0510cc67$export$fdaf2fd6d7edde95 = $e30cd69d0510cc67$var$buildMatchPatternFn;
function $e30cd69d0510cc67$var$buildMatchPatternFn(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


const $10a3d575eaf4b44f$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $10a3d575eaf4b44f$var$parseOrdinalNumberPattern = /\d+/i;
const $10a3d575eaf4b44f$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $10a3d575eaf4b44f$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $10a3d575eaf4b44f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $10a3d575eaf4b44f$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $10a3d575eaf4b44f$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $10a3d575eaf4b44f$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $10a3d575eaf4b44f$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $10a3d575eaf4b44f$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $10a3d575eaf4b44f$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $10a3d575eaf4b44f$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $10a3d575eaf4b44f$var$match = $10a3d575eaf4b44f$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $e30cd69d0510cc67$export$fdaf2fd6d7edde95)({
        matchPattern: $10a3d575eaf4b44f$var$matchOrdinalNumberPattern,
        parsePattern: $10a3d575eaf4b44f$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $60f1ebf50e69229e$export$1430a0f35710914d)({
        matchPatterns: $10a3d575eaf4b44f$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $10a3d575eaf4b44f$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $60f1ebf50e69229e$export$1430a0f35710914d)({
        matchPatterns: $10a3d575eaf4b44f$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $10a3d575eaf4b44f$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $60f1ebf50e69229e$export$1430a0f35710914d)({
        matchPatterns: $10a3d575eaf4b44f$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $10a3d575eaf4b44f$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $60f1ebf50e69229e$export$1430a0f35710914d)({
        matchPatterns: $10a3d575eaf4b44f$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $10a3d575eaf4b44f$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $60f1ebf50e69229e$export$1430a0f35710914d)({
        matchPatterns: $10a3d575eaf4b44f$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $10a3d575eaf4b44f$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


/**
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp](https://github.com/kossnocorp)
 * @author Lesha Koss [@leshakoss](https://github.com/leshakoss)
 */ const $bec673a8a764e47c$var$enUS = $bec673a8a764e47c$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: $1f0453eadb8ad666$export$2c14ff85d6318973,
    formatLong: $ffdbba01a514217d$export$cbf60ecb96cbb82f,
    formatRelative: $4e9842a07c0b25fa$export$8fbbfd65594f46a0,
    localize: $ce5b2daca8dcbc64$export$b3bd0bc58e36cd63,
    match: $10a3d575eaf4b44f$export$4659b591c19bdf3d,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};




var $4fbe1464a340849e$export$430a3269e24b912e;
var $4fbe1464a340849e$export$95365be1b0704abc;
"use strict";
$4fbe1464a340849e$export$430a3269e24b912e = $4fbe1464a340849e$var$getDefaultOptions;
$4fbe1464a340849e$export$95365be1b0704abc = $4fbe1464a340849e$var$setDefaultOptions;
let $4fbe1464a340849e$var$defaultOptions = {};
function $4fbe1464a340849e$var$getDefaultOptions() {
    return $4fbe1464a340849e$var$defaultOptions;
}
function $4fbe1464a340849e$var$setDefaultOptions(newOptions) {
    $4fbe1464a340849e$var$defaultOptions = newOptions;
}


var $74a92283fe8a9cad$export$fe98a034cfb96d55;
"use strict";
$74a92283fe8a9cad$export$fe98a034cfb96d55 = void 0;

var $264acfd4da0e5bcd$export$7cabdc5698b63e2f;
"use strict";
$264acfd4da0e5bcd$export$7cabdc5698b63e2f = $264acfd4da0e5bcd$var$getISOWeek;

var $2b91f141a5805781$export$6173213f95a4431e;
"use strict";
$2b91f141a5805781$export$6173213f95a4431e = $2b91f141a5805781$var$startOfISOWeek;
var $02784f8c72f1ee0b$export$42c81a444fbfb5d4;
"use strict";
$02784f8c72f1ee0b$export$42c81a444fbfb5d4 = $02784f8c72f1ee0b$var$startOfWeek;


/**
 * The {@link startOfWeek} function options.
 */ /**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */ function $02784f8c72f1ee0b$var$startOfWeek(date, options) {
    const defaultOptions = (0, $4fbe1464a340849e$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $10272ab2063f75db$export$e67a095c620b86fe)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}


/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ function $2b91f141a5805781$var$startOfISOWeek(date) {
    return (0, $02784f8c72f1ee0b$export$42c81a444fbfb5d4)(date, {
        weekStartsOn: 1
    });
}


var $daea1483b05b50af$export$236bdfa374eb69a9;
"use strict";
$daea1483b05b50af$export$236bdfa374eb69a9 = $daea1483b05b50af$var$startOfISOWeekYear;
var $270d62d2707f1dbf$export$3dbc52535f6f8fcc;
"use strict";
$270d62d2707f1dbf$export$3dbc52535f6f8fcc = $270d62d2707f1dbf$var$getISOWeekYear;



/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */ function $270d62d2707f1dbf$var$getISOWeekYear(date) {
    const _date = (0, $10272ab2063f75db$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $637d5e857124f8fb$export$ead8a1812b171991)(date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $2b91f141a5805781$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $637d5e857124f8fb$export$ead8a1812b171991)(date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $2b91f141a5805781$export$6173213f95a4431e)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */ function $daea1483b05b50af$var$startOfISOWeekYear(date) {
    const year = (0, $270d62d2707f1dbf$export$3dbc52535f6f8fcc)(date);
    const fourthOfJanuary = (0, $637d5e857124f8fb$export$ead8a1812b171991)(date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $2b91f141a5805781$export$6173213f95a4431e)(fourthOfJanuary);
}



/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */ function $264acfd4da0e5bcd$var$getISOWeek(date) {
    const _date = (0, $10272ab2063f75db$export$e67a095c620b86fe)(date);
    const diff = +(0, $2b91f141a5805781$export$6173213f95a4431e)(_date) - +(0, $daea1483b05b50af$export$236bdfa374eb69a9)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $9e78331521a08d61$export$4fad13613e88edc8) + 1;
}



var $27b922f4ab798b50$export$efe19b760242b2fc;
"use strict";
$27b922f4ab798b50$export$efe19b760242b2fc = $27b922f4ab798b50$var$getWeek;


var $5adf2a341ea17436$export$bb7b45bb8e74da0f;
"use strict";
$5adf2a341ea17436$export$bb7b45bb8e74da0f = $5adf2a341ea17436$var$startOfWeekYear;

var $825cee101eab6802$export$12d572480ceb6e58;
"use strict";
$825cee101eab6802$export$12d572480ceb6e58 = $825cee101eab6802$var$getWeekYear;




/**
 * The {@link getWeekYear} function options.
 */ /**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */ function $825cee101eab6802$var$getWeekYear(date, options) {
    const _date = (0, $10272ab2063f75db$export$e67a095c620b86fe)(date);
    const year = _date.getFullYear();
    const defaultOptions = (0, $4fbe1464a340849e$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $637d5e857124f8fb$export$ead8a1812b171991)(date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $02784f8c72f1ee0b$export$42c81a444fbfb5d4)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $637d5e857124f8fb$export$ead8a1812b171991)(date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $02784f8c72f1ee0b$export$42c81a444fbfb5d4)(firstWeekOfThisYear, options);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




/**
 * The {@link startOfWeekYear} function options.
 */ /**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */ function $5adf2a341ea17436$var$startOfWeekYear(date, options) {
    const defaultOptions = (0, $4fbe1464a340849e$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $825cee101eab6802$export$12d572480ceb6e58)(date, options);
    const firstWeek = (0, $637d5e857124f8fb$export$ead8a1812b171991)(date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $02784f8c72f1ee0b$export$42c81a444fbfb5d4)(firstWeek, options);
    return _date;
}



/**
 * The {@link getWeek} function options.
 */ /**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */ function $27b922f4ab798b50$var$getWeek(date, options) {
    const _date = (0, $10272ab2063f75db$export$e67a095c620b86fe)(date);
    const diff = +(0, $02784f8c72f1ee0b$export$42c81a444fbfb5d4)(_date, options) - +(0, $5adf2a341ea17436$export$bb7b45bb8e74da0f)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / $9e78331521a08d61$export$4fad13613e88edc8) + 1;
}



var $c5c600d14eca30cb$export$c8306e720e213c0f;
"use strict";
$c5c600d14eca30cb$export$c8306e720e213c0f = $c5c600d14eca30cb$var$addLeadingZeros;
function $c5c600d14eca30cb$var$addLeadingZeros(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}


var $4acc4f47cf2c7318$export$b0d4b338e1516f13;
"use strict";
$4acc4f47cf2c7318$export$b0d4b338e1516f13 = void 0;

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ const $4acc4f47cf2c7318$var$lightFormatters = $4acc4f47cf2c7318$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(fractionalSeconds, token.length);
    }
};


const $74a92283fe8a9cad$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ const $74a92283fe8a9cad$var$formatters = $74a92283fe8a9cad$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return $4acc4f47cf2c7318$export$b0d4b338e1516f13.y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $825cee101eab6802$export$12d572480ceb6e58)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $270d62d2707f1dbf$export$3dbc52535f6f8fcc)(date);
        // Padding
        return (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return $4acc4f47cf2c7318$export$b0d4b338e1516f13.M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $27b922f4ab798b50$export$efe19b760242b2fc)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $264acfd4da0e5bcd$export$7cabdc5698b63e2f)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return $4acc4f47cf2c7318$export$b0d4b338e1516f13.d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $bb157686983b9d37$export$d3b42cd8452deec)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $74a92283fe8a9cad$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $74a92283fe8a9cad$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $74a92283fe8a9cad$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $74a92283fe8a9cad$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $74a92283fe8a9cad$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $74a92283fe8a9cad$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return $4acc4f47cf2c7318$export$b0d4b338e1516f13.h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return $4acc4f47cf2c7318$export$b0d4b338e1516f13.H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return $4acc4f47cf2c7318$export$b0d4b338e1516f13.m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return $4acc4f47cf2c7318$export$b0d4b338e1516f13.s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return $4acc4f47cf2c7318$export$b0d4b338e1516f13.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $74a92283fe8a9cad$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $74a92283fe8a9cad$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $74a92283fe8a9cad$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $74a92283fe8a9cad$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $74a92283fe8a9cad$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $74a92283fe8a9cad$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $74a92283fe8a9cad$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $74a92283fe8a9cad$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $74a92283fe8a9cad$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $74a92283fe8a9cad$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(date.getTime() / 1000);
        return (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        const timestamp = date.getTime();
        return (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(timestamp, token.length);
    }
};
function $74a92283fe8a9cad$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(minutes, 2);
}
function $74a92283fe8a9cad$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(Math.abs(offset) / 60, 2);
    }
    return $74a92283fe8a9cad$var$formatTimezone(offset, delimiter);
}
function $74a92283fe8a9cad$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $c5c600d14eca30cb$export$c8306e720e213c0f)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}


var $7b268c7137b61ea8$export$70cc8fd02856fd58;
"use strict";
$7b268c7137b61ea8$export$70cc8fd02856fd58 = void 0;
const $7b268c7137b61ea8$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $7b268c7137b61ea8$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $7b268c7137b61ea8$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $7b268c7137b61ea8$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $7b268c7137b61ea8$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $7b268c7137b61ea8$var$timeLongFormatter(timePattern, formatLong));
};
const $7b268c7137b61ea8$var$longFormatters = $7b268c7137b61ea8$export$70cc8fd02856fd58 = {
    p: $7b268c7137b61ea8$var$timeLongFormatter,
    P: $7b268c7137b61ea8$var$dateTimeLongFormatter
};


var $ce05c1f761cc23b3$export$c6cc36aa33304772;
var $ce05c1f761cc23b3$export$c6b49d6dceb604a1;
var $ce05c1f761cc23b3$export$f5f38f90ecaaf879;
"use strict";
$ce05c1f761cc23b3$export$c6cc36aa33304772 = $ce05c1f761cc23b3$var$isProtectedDayOfYearToken;
$ce05c1f761cc23b3$export$c6b49d6dceb604a1 = $ce05c1f761cc23b3$var$isProtectedWeekYearToken;
$ce05c1f761cc23b3$export$f5f38f90ecaaf879 = $ce05c1f761cc23b3$var$warnOrThrowProtectedError;
const $ce05c1f761cc23b3$var$dayOfYearTokenRE = /^D+$/;
const $ce05c1f761cc23b3$var$weekYearTokenRE = /^Y+$/;
const $ce05c1f761cc23b3$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $ce05c1f761cc23b3$var$isProtectedDayOfYearToken(token) {
    return $ce05c1f761cc23b3$var$dayOfYearTokenRE.test(token);
}
function $ce05c1f761cc23b3$var$isProtectedWeekYearToken(token) {
    return $ce05c1f761cc23b3$var$weekYearTokenRE.test(token);
}
function $ce05c1f761cc23b3$var$warnOrThrowProtectedError(token, format, input) {
    const _message = $ce05c1f761cc23b3$var$message(token, format, input);
    console.warn(_message);
    if ($ce05c1f761cc23b3$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $ce05c1f761cc23b3$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}


var $917ea37c5d85b51c$export$1ea939691cdc45b8;
"use strict";
$917ea37c5d85b51c$export$1ea939691cdc45b8 = $917ea37c5d85b51c$var$isValid;
var $ba6382a2fb48fab4$export$871608497c498473;
"use strict";
$ba6382a2fb48fab4$export$871608497c498473 = $ba6382a2fb48fab4$var$isDate; /**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ 
function $ba6382a2fb48fab4$var$isDate(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ function $917ea37c5d85b51c$var$isValid(date) {
    if (!(0, $ba6382a2fb48fab4$export$871608497c498473)(date) && typeof date !== "number") return false;
    const _date = (0, $10272ab2063f75db$export$e67a095c620b86fe)(date);
    return !isNaN(Number(_date));
}



// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $1232e9c9fcb8c1ea$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $1232e9c9fcb8c1ea$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $1232e9c9fcb8c1ea$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $1232e9c9fcb8c1ea$var$doubleQuoteRegExp = /''/g;
const $1232e9c9fcb8c1ea$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * The {@link format} function options.
 */ /**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $1232e9c9fcb8c1ea$var$format(date, formatStr, options) {
    const defaultOptions = (0, $4fbe1464a340849e$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? $4a3b8322c1a23c85$exports.defaultLocale;
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $10272ab2063f75db$export$e67a095c620b86fe)(date);
    if (!(0, $917ea37c5d85b51c$export$1ea939691cdc45b8)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($1232e9c9fcb8c1ea$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = $7b268c7137b61ea8$export$70cc8fd02856fd58[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($1232e9c9fcb8c1ea$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $1232e9c9fcb8c1ea$var$cleanEscapedString(substring)
        };
        if ($74a92283fe8a9cad$export$fe98a034cfb96d55[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($1232e9c9fcb8c1ea$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $ce05c1f761cc23b3$export$c6b49d6dceb604a1)(token) || !options?.useAdditionalDayOfYearTokens && (0, $ce05c1f761cc23b3$export$c6cc36aa33304772)(token)) (0, $ce05c1f761cc23b3$export$f5f38f90ecaaf879)(token, formatStr, String(date));
        const formatter = $74a92283fe8a9cad$export$fe98a034cfb96d55[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $1232e9c9fcb8c1ea$var$cleanEscapedString(input) {
    const matched = input.match($1232e9c9fcb8c1ea$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($1232e9c9fcb8c1ea$var$doubleQuoteRegExp, "'");
}


var $71a2f7370c181ea9$exports = {};
var $45d84ad205a796a7$exports = {};
var $d5e92bedd2d5ea11$exports = {};
var $863fe6bcb1ee042f$exports = {};
var $3a0e7e6cef79d3f0$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $3a0e7e6cef79d3f0$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$3a0e7e6cef79d3f0$exports = $3a0e7e6cef79d3f0$var$listCacheClear;


var $be26bc847aadb2cf$exports = {};
var $dc88429c65a02b1f$exports = {};
var $4848ae3ccf4ff248$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $4848ae3ccf4ff248$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$4848ae3ccf4ff248$exports = $4848ae3ccf4ff248$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $dc88429c65a02b1f$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($4848ae3ccf4ff248$exports(array[length][0], key)) return length;
    }
    return -1;
}
$dc88429c65a02b1f$exports = $dc88429c65a02b1f$var$assocIndexOf;


/** Used for built-in method references. */ var $be26bc847aadb2cf$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $be26bc847aadb2cf$var$splice = $be26bc847aadb2cf$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $be26bc847aadb2cf$var$listCacheDelete(key) {
    var data = this.__data__, index = $dc88429c65a02b1f$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $be26bc847aadb2cf$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$be26bc847aadb2cf$exports = $be26bc847aadb2cf$var$listCacheDelete;


var $3f6c7c4e089edd0c$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $3f6c7c4e089edd0c$var$listCacheGet(key) {
    var data = this.__data__, index = $dc88429c65a02b1f$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$3f6c7c4e089edd0c$exports = $3f6c7c4e089edd0c$var$listCacheGet;


var $d39a303519dea499$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d39a303519dea499$var$listCacheHas(key) {
    return $dc88429c65a02b1f$exports(this.__data__, key) > -1;
}
$d39a303519dea499$exports = $d39a303519dea499$var$listCacheHas;


var $b344e70b52862e5a$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $b344e70b52862e5a$var$listCacheSet(key, value) {
    var data = this.__data__, index = $dc88429c65a02b1f$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$b344e70b52862e5a$exports = $b344e70b52862e5a$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $863fe6bcb1ee042f$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$863fe6bcb1ee042f$var$ListCache.prototype.clear = $3a0e7e6cef79d3f0$exports;
$863fe6bcb1ee042f$var$ListCache.prototype["delete"] = $be26bc847aadb2cf$exports;
$863fe6bcb1ee042f$var$ListCache.prototype.get = $3f6c7c4e089edd0c$exports;
$863fe6bcb1ee042f$var$ListCache.prototype.has = $d39a303519dea499$exports;
$863fe6bcb1ee042f$var$ListCache.prototype.set = $b344e70b52862e5a$exports;
$863fe6bcb1ee042f$exports = $863fe6bcb1ee042f$var$ListCache;


var $98d32cbeed0a0919$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $98d32cbeed0a0919$var$stackClear() {
    this.__data__ = new $863fe6bcb1ee042f$exports;
    this.size = 0;
}
$98d32cbeed0a0919$exports = $98d32cbeed0a0919$var$stackClear;


var $b8d37ca77ce9a621$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b8d37ca77ce9a621$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
$b8d37ca77ce9a621$exports = $b8d37ca77ce9a621$var$stackDelete;


var $d4417027767ba1dc$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $d4417027767ba1dc$var$stackGet(key) {
    return this.__data__.get(key);
}
$d4417027767ba1dc$exports = $d4417027767ba1dc$var$stackGet;


var $d5ed6eb79d8c7308$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d5ed6eb79d8c7308$var$stackHas(key) {
    return this.__data__.has(key);
}
$d5ed6eb79d8c7308$exports = $d5ed6eb79d8c7308$var$stackHas;


var $bdf776931c133b95$exports = {};

var $9080706ebb9e67eb$exports = {};
var $99c4ba84188f46b8$exports = {};
var $85cf571eb43ec6f7$exports = {};
var $3a2d755df4c00d46$exports = {};
var $a417b04763129f1c$exports = {};
var $24222c5e026539d1$exports = {};

var $joIhc = parcelRequire("joIhc");
/** Built-in value references. */ var $24222c5e026539d1$var$Symbol = $joIhc.Symbol;
$24222c5e026539d1$exports = $24222c5e026539d1$var$Symbol;


var $d5a2c4cb9feb0d76$exports = {};

/** Used for built-in method references. */ var $d5a2c4cb9feb0d76$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d5a2c4cb9feb0d76$var$hasOwnProperty = $d5a2c4cb9feb0d76$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $d5a2c4cb9feb0d76$var$nativeObjectToString = $d5a2c4cb9feb0d76$var$objectProto.toString;
/** Built-in value references. */ var $d5a2c4cb9feb0d76$var$symToStringTag = $24222c5e026539d1$exports ? $24222c5e026539d1$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $d5a2c4cb9feb0d76$var$getRawTag(value) {
    var isOwn = $d5a2c4cb9feb0d76$var$hasOwnProperty.call(value, $d5a2c4cb9feb0d76$var$symToStringTag), tag = value[$d5a2c4cb9feb0d76$var$symToStringTag];
    try {
        value[$d5a2c4cb9feb0d76$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $d5a2c4cb9feb0d76$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$d5a2c4cb9feb0d76$var$symToStringTag] = tag;
        else delete value[$d5a2c4cb9feb0d76$var$symToStringTag];
    }
    return result;
}
$d5a2c4cb9feb0d76$exports = $d5a2c4cb9feb0d76$var$getRawTag;


var $b787ae3208ebc449$exports = {};
/** Used for built-in method references. */ var $b787ae3208ebc449$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b787ae3208ebc449$var$nativeObjectToString = $b787ae3208ebc449$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $b787ae3208ebc449$var$objectToString(value) {
    return $b787ae3208ebc449$var$nativeObjectToString.call(value);
}
$b787ae3208ebc449$exports = $b787ae3208ebc449$var$objectToString;


/** `Object#toString` result references. */ var $a417b04763129f1c$var$nullTag = "[object Null]", $a417b04763129f1c$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $a417b04763129f1c$var$symToStringTag = $24222c5e026539d1$exports ? $24222c5e026539d1$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a417b04763129f1c$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a417b04763129f1c$var$undefinedTag : $a417b04763129f1c$var$nullTag;
    return $a417b04763129f1c$var$symToStringTag && $a417b04763129f1c$var$symToStringTag in Object(value) ? $d5a2c4cb9feb0d76$exports(value) : $b787ae3208ebc449$exports(value);
}
$a417b04763129f1c$exports = $a417b04763129f1c$var$baseGetTag;


var $1f672fed7efed57e$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $1f672fed7efed57e$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$1f672fed7efed57e$exports = $1f672fed7efed57e$var$isObject;


/** `Object#toString` result references. */ var $3a2d755df4c00d46$var$asyncTag = "[object AsyncFunction]", $3a2d755df4c00d46$var$funcTag = "[object Function]", $3a2d755df4c00d46$var$genTag = "[object GeneratorFunction]", $3a2d755df4c00d46$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $3a2d755df4c00d46$var$isFunction(value) {
    if (!$1f672fed7efed57e$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $a417b04763129f1c$exports(value);
    return tag == $3a2d755df4c00d46$var$funcTag || tag == $3a2d755df4c00d46$var$genTag || tag == $3a2d755df4c00d46$var$asyncTag || tag == $3a2d755df4c00d46$var$proxyTag;
}
$3a2d755df4c00d46$exports = $3a2d755df4c00d46$var$isFunction;


var $5f7294f63a4d6e50$exports = {};
var $14e0ce709c02a3ed$exports = {};

var $joIhc = parcelRequire("joIhc");
/** Used to detect overreaching core-js shims. */ var $14e0ce709c02a3ed$var$coreJsData = $joIhc["__core-js_shared__"];
$14e0ce709c02a3ed$exports = $14e0ce709c02a3ed$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $5f7294f63a4d6e50$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($14e0ce709c02a3ed$exports && $14e0ce709c02a3ed$exports.keys && $14e0ce709c02a3ed$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5f7294f63a4d6e50$var$isMasked(func) {
    return !!$5f7294f63a4d6e50$var$maskSrcKey && $5f7294f63a4d6e50$var$maskSrcKey in func;
}
$5f7294f63a4d6e50$exports = $5f7294f63a4d6e50$var$isMasked;



var $0e86857f8765348f$exports = {};
/** Used for built-in method references. */ var $0e86857f8765348f$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $0e86857f8765348f$var$funcToString = $0e86857f8765348f$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $0e86857f8765348f$var$toSource(func) {
    if (func != null) {
        try {
            return $0e86857f8765348f$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$0e86857f8765348f$exports = $0e86857f8765348f$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $85cf571eb43ec6f7$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $85cf571eb43ec6f7$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $85cf571eb43ec6f7$var$funcProto = Function.prototype, $85cf571eb43ec6f7$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $85cf571eb43ec6f7$var$funcToString = $85cf571eb43ec6f7$var$funcProto.toString;
/** Used to check objects for own properties. */ var $85cf571eb43ec6f7$var$hasOwnProperty = $85cf571eb43ec6f7$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $85cf571eb43ec6f7$var$reIsNative = RegExp("^" + $85cf571eb43ec6f7$var$funcToString.call($85cf571eb43ec6f7$var$hasOwnProperty).replace($85cf571eb43ec6f7$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $85cf571eb43ec6f7$var$baseIsNative(value) {
    if (!$1f672fed7efed57e$exports(value) || $5f7294f63a4d6e50$exports(value)) return false;
    var pattern = $3a2d755df4c00d46$exports(value) ? $85cf571eb43ec6f7$var$reIsNative : $85cf571eb43ec6f7$var$reIsHostCtor;
    return pattern.test($0e86857f8765348f$exports(value));
}
$85cf571eb43ec6f7$exports = $85cf571eb43ec6f7$var$baseIsNative;


var $970b8c440941f295$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $970b8c440941f295$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$970b8c440941f295$exports = $970b8c440941f295$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $99c4ba84188f46b8$var$getNative(object, key) {
    var value = $970b8c440941f295$exports(object, key);
    return $85cf571eb43ec6f7$exports(value) ? value : undefined;
}
$99c4ba84188f46b8$exports = $99c4ba84188f46b8$var$getNative;



var $joIhc = parcelRequire("joIhc");
/* Built-in method references that are verified to be native. */ var $9080706ebb9e67eb$var$Map = $99c4ba84188f46b8$exports($joIhc, "Map");
$9080706ebb9e67eb$exports = $9080706ebb9e67eb$var$Map;


var $7114986f3690d6bb$exports = {};
var $7edea9b855d2efe7$exports = {};
var $843ce0a50c0e8fd0$exports = {};
var $a3feb77dfaa74a8a$exports = {};
var $01a4bcb576291393$exports = {};

/* Built-in method references that are verified to be native. */ var $01a4bcb576291393$var$nativeCreate = $99c4ba84188f46b8$exports(Object, "create");
$01a4bcb576291393$exports = $01a4bcb576291393$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $a3feb77dfaa74a8a$var$hashClear() {
    this.__data__ = $01a4bcb576291393$exports ? $01a4bcb576291393$exports(null) : {};
    this.size = 0;
}
$a3feb77dfaa74a8a$exports = $a3feb77dfaa74a8a$var$hashClear;


var $6bf6c867325d7420$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $6bf6c867325d7420$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$6bf6c867325d7420$exports = $6bf6c867325d7420$var$hashDelete;


var $87b2b5ae8f2da186$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $87b2b5ae8f2da186$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $87b2b5ae8f2da186$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $87b2b5ae8f2da186$var$hasOwnProperty = $87b2b5ae8f2da186$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $87b2b5ae8f2da186$var$hashGet(key) {
    var data = this.__data__;
    if ($01a4bcb576291393$exports) {
        var result = data[key];
        return result === $87b2b5ae8f2da186$var$HASH_UNDEFINED ? undefined : result;
    }
    return $87b2b5ae8f2da186$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$87b2b5ae8f2da186$exports = $87b2b5ae8f2da186$var$hashGet;


var $efadf49f440438ed$exports = {};

/** Used for built-in method references. */ var $efadf49f440438ed$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $efadf49f440438ed$var$hasOwnProperty = $efadf49f440438ed$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $efadf49f440438ed$var$hashHas(key) {
    var data = this.__data__;
    return $01a4bcb576291393$exports ? data[key] !== undefined : $efadf49f440438ed$var$hasOwnProperty.call(data, key);
}
$efadf49f440438ed$exports = $efadf49f440438ed$var$hashHas;


var $431f2524acae7bda$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $431f2524acae7bda$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $431f2524acae7bda$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $01a4bcb576291393$exports && value === undefined ? $431f2524acae7bda$var$HASH_UNDEFINED : value;
    return this;
}
$431f2524acae7bda$exports = $431f2524acae7bda$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $843ce0a50c0e8fd0$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$843ce0a50c0e8fd0$var$Hash.prototype.clear = $a3feb77dfaa74a8a$exports;
$843ce0a50c0e8fd0$var$Hash.prototype["delete"] = $6bf6c867325d7420$exports;
$843ce0a50c0e8fd0$var$Hash.prototype.get = $87b2b5ae8f2da186$exports;
$843ce0a50c0e8fd0$var$Hash.prototype.has = $efadf49f440438ed$exports;
$843ce0a50c0e8fd0$var$Hash.prototype.set = $431f2524acae7bda$exports;
$843ce0a50c0e8fd0$exports = $843ce0a50c0e8fd0$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $7edea9b855d2efe7$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $843ce0a50c0e8fd0$exports,
        "map": new ($9080706ebb9e67eb$exports || $863fe6bcb1ee042f$exports),
        "string": new $843ce0a50c0e8fd0$exports
    };
}
$7edea9b855d2efe7$exports = $7edea9b855d2efe7$var$mapCacheClear;


var $1c9b7ae2be76128b$exports = {};
var $e392cb91d1ada0e9$exports = {};
var $b4fa6cbc0b7701cd$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $b4fa6cbc0b7701cd$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$b4fa6cbc0b7701cd$exports = $b4fa6cbc0b7701cd$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $e392cb91d1ada0e9$var$getMapData(map, key) {
    var data = map.__data__;
    return $b4fa6cbc0b7701cd$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$e392cb91d1ada0e9$exports = $e392cb91d1ada0e9$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $1c9b7ae2be76128b$var$mapCacheDelete(key) {
    var result = $e392cb91d1ada0e9$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$1c9b7ae2be76128b$exports = $1c9b7ae2be76128b$var$mapCacheDelete;


var $5f90de34d8245763$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $5f90de34d8245763$var$mapCacheGet(key) {
    return $e392cb91d1ada0e9$exports(this, key).get(key);
}
$5f90de34d8245763$exports = $5f90de34d8245763$var$mapCacheGet;


var $c3da1b384e2765d1$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c3da1b384e2765d1$var$mapCacheHas(key) {
    return $e392cb91d1ada0e9$exports(this, key).has(key);
}
$c3da1b384e2765d1$exports = $c3da1b384e2765d1$var$mapCacheHas;


var $ca7cee5355763bc3$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $ca7cee5355763bc3$var$mapCacheSet(key, value) {
    var data = $e392cb91d1ada0e9$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$ca7cee5355763bc3$exports = $ca7cee5355763bc3$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $7114986f3690d6bb$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$7114986f3690d6bb$var$MapCache.prototype.clear = $7edea9b855d2efe7$exports;
$7114986f3690d6bb$var$MapCache.prototype["delete"] = $1c9b7ae2be76128b$exports;
$7114986f3690d6bb$var$MapCache.prototype.get = $5f90de34d8245763$exports;
$7114986f3690d6bb$var$MapCache.prototype.has = $c3da1b384e2765d1$exports;
$7114986f3690d6bb$var$MapCache.prototype.set = $ca7cee5355763bc3$exports;
$7114986f3690d6bb$exports = $7114986f3690d6bb$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $bdf776931c133b95$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $bdf776931c133b95$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $863fe6bcb1ee042f$exports) {
        var pairs = data.__data__;
        if (!$9080706ebb9e67eb$exports || pairs.length < $bdf776931c133b95$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $7114986f3690d6bb$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$bdf776931c133b95$exports = $bdf776931c133b95$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $d5e92bedd2d5ea11$var$Stack(entries) {
    var data = this.__data__ = new $863fe6bcb1ee042f$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$d5e92bedd2d5ea11$var$Stack.prototype.clear = $98d32cbeed0a0919$exports;
$d5e92bedd2d5ea11$var$Stack.prototype["delete"] = $b8d37ca77ce9a621$exports;
$d5e92bedd2d5ea11$var$Stack.prototype.get = $d4417027767ba1dc$exports;
$d5e92bedd2d5ea11$var$Stack.prototype.has = $d5ed6eb79d8c7308$exports;
$d5e92bedd2d5ea11$var$Stack.prototype.set = $bdf776931c133b95$exports;
$d5e92bedd2d5ea11$exports = $d5e92bedd2d5ea11$var$Stack;


var $17488e8d7d0cdc10$exports = {};
var $756cf19440863941$exports = {};
var $1ce0cf72dd2e5e9c$exports = {};

var $1ce0cf72dd2e5e9c$var$defineProperty = function() {
    try {
        var func = $99c4ba84188f46b8$exports(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
$1ce0cf72dd2e5e9c$exports = $1ce0cf72dd2e5e9c$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $756cf19440863941$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $1ce0cf72dd2e5e9c$exports) $1ce0cf72dd2e5e9c$exports(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
$756cf19440863941$exports = $756cf19440863941$var$baseAssignValue;



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $17488e8d7d0cdc10$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$4848ae3ccf4ff248$exports(object[key], value) || value === undefined && !(key in object)) $756cf19440863941$exports(object, key, value);
}
$17488e8d7d0cdc10$exports = $17488e8d7d0cdc10$var$assignMergeValue;


var $bfe3f3461232eafe$exports = {};
var $b96851c7fe087daf$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $b96851c7fe087daf$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$b96851c7fe087daf$exports = $b96851c7fe087daf$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $bfe3f3461232eafe$var$baseFor = $b96851c7fe087daf$exports();
$bfe3f3461232eafe$exports = $bfe3f3461232eafe$var$baseFor;


var $ccf65c846c24bb80$exports = {};


var $hALax = parcelRequire("hALax");
var $bea24b8368e2f3a9$exports = {};
var $296f1d0c483a4c7f$exports = {};
var $86c3dc68dadedaa9$exports = {};

var $joIhc = parcelRequire("joIhc");
/** Built-in value references. */ var $86c3dc68dadedaa9$var$Uint8Array = $joIhc.Uint8Array;
$86c3dc68dadedaa9$exports = $86c3dc68dadedaa9$var$Uint8Array;


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $296f1d0c483a4c7f$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $86c3dc68dadedaa9$exports(result).set(new $86c3dc68dadedaa9$exports(arrayBuffer));
    return result;
}
$296f1d0c483a4c7f$exports = $296f1d0c483a4c7f$var$cloneArrayBuffer;


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $bea24b8368e2f3a9$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $296f1d0c483a4c7f$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$bea24b8368e2f3a9$exports = $bea24b8368e2f3a9$var$cloneTypedArray;


var $a9e13b6465cd2727$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $a9e13b6465cd2727$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$a9e13b6465cd2727$exports = $a9e13b6465cd2727$var$copyArray;


var $57dd3dc024b5ccce$exports = {};
var $1ea193907c9aa84a$exports = {};

/** Built-in value references. */ var $1ea193907c9aa84a$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $1ea193907c9aa84a$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$1f672fed7efed57e$exports(proto)) return {};
        if ($1ea193907c9aa84a$var$objectCreate) return $1ea193907c9aa84a$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$1ea193907c9aa84a$exports = $1ea193907c9aa84a$var$baseCreate;


var $cb22bd8c4deddb0f$exports = {};
var $0085f28775c6c6c3$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $0085f28775c6c6c3$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$0085f28775c6c6c3$exports = $0085f28775c6c6c3$var$overArg;


/** Built-in value references. */ var $cb22bd8c4deddb0f$var$getPrototype = $0085f28775c6c6c3$exports(Object.getPrototypeOf, Object);
$cb22bd8c4deddb0f$exports = $cb22bd8c4deddb0f$var$getPrototype;


var $48d2914fd2666d71$exports = {};
/** Used for built-in method references. */ var $48d2914fd2666d71$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $48d2914fd2666d71$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $48d2914fd2666d71$var$objectProto;
    return value === proto;
}
$48d2914fd2666d71$exports = $48d2914fd2666d71$var$isPrototype;


/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $57dd3dc024b5ccce$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !$48d2914fd2666d71$exports(object) ? $1ea193907c9aa84a$exports($cb22bd8c4deddb0f$exports(object)) : {};
}
$57dd3dc024b5ccce$exports = $57dd3dc024b5ccce$var$initCloneObject;


var $28c4d821de31f25d$exports = {};
var $c455b6f9d32b6617$exports = {};

var $34a8c8cbd9ebf965$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $34a8c8cbd9ebf965$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$34a8c8cbd9ebf965$exports = $34a8c8cbd9ebf965$var$isObjectLike;


/** `Object#toString` result references. */ var $c455b6f9d32b6617$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $c455b6f9d32b6617$var$baseIsArguments(value) {
    return $34a8c8cbd9ebf965$exports(value) && $a417b04763129f1c$exports(value) == $c455b6f9d32b6617$var$argsTag;
}
$c455b6f9d32b6617$exports = $c455b6f9d32b6617$var$baseIsArguments;



/** Used for built-in method references. */ var $28c4d821de31f25d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $28c4d821de31f25d$var$hasOwnProperty = $28c4d821de31f25d$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $28c4d821de31f25d$var$propertyIsEnumerable = $28c4d821de31f25d$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $28c4d821de31f25d$var$isArguments = $c455b6f9d32b6617$exports(function() {
    return arguments;
}()) ? $c455b6f9d32b6617$exports : function(value) {
    return $34a8c8cbd9ebf965$exports(value) && $28c4d821de31f25d$var$hasOwnProperty.call(value, "callee") && !$28c4d821de31f25d$var$propertyIsEnumerable.call(value, "callee");
};
$28c4d821de31f25d$exports = $28c4d821de31f25d$var$isArguments;


var $0222e83d73c8b1f6$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0222e83d73c8b1f6$var$isArray = Array.isArray;
$0222e83d73c8b1f6$exports = $0222e83d73c8b1f6$var$isArray;


var $a99178c1df6630f8$exports = {};
var $1dea69b96520dc48$exports = {};

var $9acf46d15a35c301$exports = {};
/** Used as references for various `Number` constants. */ var $9acf46d15a35c301$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $9acf46d15a35c301$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $9acf46d15a35c301$var$MAX_SAFE_INTEGER;
}
$9acf46d15a35c301$exports = $9acf46d15a35c301$var$isLength;


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $1dea69b96520dc48$var$isArrayLike(value) {
    return value != null && $9acf46d15a35c301$exports(value.length) && !$3a2d755df4c00d46$exports(value);
}
$1dea69b96520dc48$exports = $1dea69b96520dc48$var$isArrayLike;



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $a99178c1df6630f8$var$isArrayLikeObject(value) {
    return $34a8c8cbd9ebf965$exports(value) && $1dea69b96520dc48$exports(value);
}
$a99178c1df6630f8$exports = $a99178c1df6630f8$var$isArrayLikeObject;



var $6FHvm = parcelRequire("6FHvm");


var $280d7aca2b2fc458$exports = {};



/** `Object#toString` result references. */ var $280d7aca2b2fc458$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $280d7aca2b2fc458$var$funcProto = Function.prototype, $280d7aca2b2fc458$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $280d7aca2b2fc458$var$funcToString = $280d7aca2b2fc458$var$funcProto.toString;
/** Used to check objects for own properties. */ var $280d7aca2b2fc458$var$hasOwnProperty = $280d7aca2b2fc458$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $280d7aca2b2fc458$var$objectCtorString = $280d7aca2b2fc458$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $280d7aca2b2fc458$var$isPlainObject(value) {
    if (!$34a8c8cbd9ebf965$exports(value) || $a417b04763129f1c$exports(value) != $280d7aca2b2fc458$var$objectTag) return false;
    var proto = $cb22bd8c4deddb0f$exports(value);
    if (proto === null) return true;
    var Ctor = $280d7aca2b2fc458$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $280d7aca2b2fc458$var$funcToString.call(Ctor) == $280d7aca2b2fc458$var$objectCtorString;
}
$280d7aca2b2fc458$exports = $280d7aca2b2fc458$var$isPlainObject;


var $77d8992c4d6343fc$exports = {};
var $6cba791471d26f8f$exports = {};



/** `Object#toString` result references. */ var $6cba791471d26f8f$var$argsTag = "[object Arguments]", $6cba791471d26f8f$var$arrayTag = "[object Array]", $6cba791471d26f8f$var$boolTag = "[object Boolean]", $6cba791471d26f8f$var$dateTag = "[object Date]", $6cba791471d26f8f$var$errorTag = "[object Error]", $6cba791471d26f8f$var$funcTag = "[object Function]", $6cba791471d26f8f$var$mapTag = "[object Map]", $6cba791471d26f8f$var$numberTag = "[object Number]", $6cba791471d26f8f$var$objectTag = "[object Object]", $6cba791471d26f8f$var$regexpTag = "[object RegExp]", $6cba791471d26f8f$var$setTag = "[object Set]", $6cba791471d26f8f$var$stringTag = "[object String]", $6cba791471d26f8f$var$weakMapTag = "[object WeakMap]";
var $6cba791471d26f8f$var$arrayBufferTag = "[object ArrayBuffer]", $6cba791471d26f8f$var$dataViewTag = "[object DataView]", $6cba791471d26f8f$var$float32Tag = "[object Float32Array]", $6cba791471d26f8f$var$float64Tag = "[object Float64Array]", $6cba791471d26f8f$var$int8Tag = "[object Int8Array]", $6cba791471d26f8f$var$int16Tag = "[object Int16Array]", $6cba791471d26f8f$var$int32Tag = "[object Int32Array]", $6cba791471d26f8f$var$uint8Tag = "[object Uint8Array]", $6cba791471d26f8f$var$uint8ClampedTag = "[object Uint8ClampedArray]", $6cba791471d26f8f$var$uint16Tag = "[object Uint16Array]", $6cba791471d26f8f$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $6cba791471d26f8f$var$typedArrayTags = {};
$6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$float32Tag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$float64Tag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$int8Tag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$int16Tag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$int32Tag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$uint8Tag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$uint8ClampedTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$uint16Tag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$uint32Tag] = true;
$6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$argsTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$arrayTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$arrayBufferTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$boolTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$dataViewTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$dateTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$errorTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$funcTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$mapTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$numberTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$objectTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$regexpTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$setTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$stringTag] = $6cba791471d26f8f$var$typedArrayTags[$6cba791471d26f8f$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $6cba791471d26f8f$var$baseIsTypedArray(value) {
    return $34a8c8cbd9ebf965$exports(value) && $9acf46d15a35c301$exports(value.length) && !!$6cba791471d26f8f$var$typedArrayTags[$a417b04763129f1c$exports(value)];
}
$6cba791471d26f8f$exports = $6cba791471d26f8f$var$baseIsTypedArray;


var $10179b7ab4d6a4cf$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $10179b7ab4d6a4cf$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$10179b7ab4d6a4cf$exports = $10179b7ab4d6a4cf$var$baseUnary;



var $9f4Zz = parcelRequire("9f4Zz");
/* Node.js helper references. */ var $77d8992c4d6343fc$var$nodeIsTypedArray = $9f4Zz && $9f4Zz.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $77d8992c4d6343fc$var$isTypedArray = $77d8992c4d6343fc$var$nodeIsTypedArray ? $10179b7ab4d6a4cf$exports($77d8992c4d6343fc$var$nodeIsTypedArray) : $6cba791471d26f8f$exports;
$77d8992c4d6343fc$exports = $77d8992c4d6343fc$var$isTypedArray;


var $66df5a5d5f9298c6$exports = {};
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $66df5a5d5f9298c6$var$safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
$66df5a5d5f9298c6$exports = $66df5a5d5f9298c6$var$safeGet;


var $1c7682f9ff7e4bae$exports = {};
var $172617afd049614d$exports = {};
var $7b1057d01f0e2b18$exports = {};


/** Used for built-in method references. */ var $7b1057d01f0e2b18$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7b1057d01f0e2b18$var$hasOwnProperty = $7b1057d01f0e2b18$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $7b1057d01f0e2b18$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($7b1057d01f0e2b18$var$hasOwnProperty.call(object, key) && $4848ae3ccf4ff248$exports(objValue, value)) || value === undefined && !(key in object)) $756cf19440863941$exports(object, key, value);
}
$7b1057d01f0e2b18$exports = $7b1057d01f0e2b18$var$assignValue;



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $172617afd049614d$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $756cf19440863941$exports(object, key, newValue);
        else $7b1057d01f0e2b18$exports(object, key, newValue);
    }
    return object;
}
$172617afd049614d$exports = $172617afd049614d$var$copyObject;


var $5e3853f2fbf8b720$exports = {};
var $b1ae9769a1c9d88e$exports = {};
var $fbc6683ade31ba90$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $fbc6683ade31ba90$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$fbc6683ade31ba90$exports = $fbc6683ade31ba90$var$baseTimes;





var $6FHvm = parcelRequire("6FHvm");
var $1360731602f19189$exports = {};
/** Used as references for various `Number` constants. */ var $1360731602f19189$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $1360731602f19189$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $1360731602f19189$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $1360731602f19189$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $1360731602f19189$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$1360731602f19189$exports = $1360731602f19189$var$isIndex;



/** Used for built-in method references. */ var $b1ae9769a1c9d88e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b1ae9769a1c9d88e$var$hasOwnProperty = $b1ae9769a1c9d88e$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $b1ae9769a1c9d88e$var$arrayLikeKeys(value, inherited) {
    var isArr = $0222e83d73c8b1f6$exports(value), isArg = !isArr && $28c4d821de31f25d$exports(value), isBuff = !isArr && !isArg && $6FHvm(value), isType = !isArr && !isArg && !isBuff && $77d8992c4d6343fc$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $fbc6683ade31ba90$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $b1ae9769a1c9d88e$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $1360731602f19189$exports(key, length)))) result.push(key);
    return result;
}
$b1ae9769a1c9d88e$exports = $b1ae9769a1c9d88e$var$arrayLikeKeys;


var $d4c2075c25137685$exports = {};


var $53345371d5b0e7fa$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $53345371d5b0e7fa$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$53345371d5b0e7fa$exports = $53345371d5b0e7fa$var$nativeKeysIn;


/** Used for built-in method references. */ var $d4c2075c25137685$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d4c2075c25137685$var$hasOwnProperty = $d4c2075c25137685$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $d4c2075c25137685$var$baseKeysIn(object) {
    if (!$1f672fed7efed57e$exports(object)) return $53345371d5b0e7fa$exports(object);
    var isProto = $48d2914fd2666d71$exports(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$d4c2075c25137685$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$d4c2075c25137685$exports = $d4c2075c25137685$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $5e3853f2fbf8b720$var$keysIn(object) {
    return $1dea69b96520dc48$exports(object) ? $b1ae9769a1c9d88e$exports(object, true) : $d4c2075c25137685$exports(object);
}
$5e3853f2fbf8b720$exports = $5e3853f2fbf8b720$var$keysIn;


/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $1c7682f9ff7e4bae$var$toPlainObject(value) {
    return $172617afd049614d$exports(value, $5e3853f2fbf8b720$exports(value));
}
$1c7682f9ff7e4bae$exports = $1c7682f9ff7e4bae$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $ccf65c846c24bb80$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $66df5a5d5f9298c6$exports(object, key), srcValue = $66df5a5d5f9298c6$exports(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $17488e8d7d0cdc10$exports(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $0222e83d73c8b1f6$exports(srcValue), isBuff = !isArr && $6FHvm(srcValue), isTyped = !isArr && !isBuff && $77d8992c4d6343fc$exports(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($0222e83d73c8b1f6$exports(objValue)) newValue = objValue;
            else if ($a99178c1df6630f8$exports(objValue)) newValue = $a9e13b6465cd2727$exports(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $hALax(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $bea24b8368e2f3a9$exports(srcValue, true);
            } else newValue = [];
        } else if ($280d7aca2b2fc458$exports(srcValue) || $28c4d821de31f25d$exports(srcValue)) {
            newValue = objValue;
            if ($28c4d821de31f25d$exports(objValue)) newValue = $1c7682f9ff7e4bae$exports(objValue);
            else if (!$1f672fed7efed57e$exports(objValue) || $3a2d755df4c00d46$exports(objValue)) newValue = $57dd3dc024b5ccce$exports(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    $17488e8d7d0cdc10$exports(object, key, newValue);
}
$ccf65c846c24bb80$exports = $ccf65c846c24bb80$var$baseMergeDeep;





/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $45d84ad205a796a7$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $bfe3f3461232eafe$exports(source, function(srcValue, key) {
        stack || (stack = new $d5e92bedd2d5ea11$exports);
        if ($1f672fed7efed57e$exports(srcValue)) $ccf65c846c24bb80$exports(object, source, key, srcIndex, $45d84ad205a796a7$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($66df5a5d5f9298c6$exports(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $17488e8d7d0cdc10$exports(object, key, newValue);
        }
    }, $5e3853f2fbf8b720$exports);
}
$45d84ad205a796a7$exports = $45d84ad205a796a7$var$baseMerge;


var $b5755d2fee0b64bc$exports = {};
var $d54bc3387ae0143f$exports = {};
var $a01605c0b9170e37$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $a01605c0b9170e37$var$identity(value) {
    return value;
}
$a01605c0b9170e37$exports = $a01605c0b9170e37$var$identity;


var $402fb9ee710cffc6$exports = {};
var $b36f5643ed95091a$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $b36f5643ed95091a$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$b36f5643ed95091a$exports = $b36f5643ed95091a$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $402fb9ee710cffc6$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $402fb9ee710cffc6$var$overRest(func, start, transform) {
    start = $402fb9ee710cffc6$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $402fb9ee710cffc6$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $b36f5643ed95091a$exports(func, this, otherArgs);
    };
}
$402fb9ee710cffc6$exports = $402fb9ee710cffc6$var$overRest;


var $9c5f9147b3854162$exports = {};
var $4656e540f2f73d29$exports = {};
var $90a720beacf17532$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $90a720beacf17532$var$constant(value) {
    return function() {
        return value;
    };
}
$90a720beacf17532$exports = $90a720beacf17532$var$constant;




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $4656e540f2f73d29$var$baseSetToString = !$1ce0cf72dd2e5e9c$exports ? $a01605c0b9170e37$exports : function(func, string) {
    return $1ce0cf72dd2e5e9c$exports(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $90a720beacf17532$exports(string),
        "writable": true
    });
};
$4656e540f2f73d29$exports = $4656e540f2f73d29$var$baseSetToString;


var $3631767a021b93d9$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $3631767a021b93d9$var$HOT_COUNT = 800, $3631767a021b93d9$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3631767a021b93d9$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $3631767a021b93d9$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $3631767a021b93d9$var$nativeNow(), remaining = $3631767a021b93d9$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $3631767a021b93d9$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$3631767a021b93d9$exports = $3631767a021b93d9$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $9c5f9147b3854162$var$setToString = $3631767a021b93d9$exports($4656e540f2f73d29$exports);
$9c5f9147b3854162$exports = $9c5f9147b3854162$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $d54bc3387ae0143f$var$baseRest(func, start) {
    return $9c5f9147b3854162$exports($402fb9ee710cffc6$exports(func, start, $a01605c0b9170e37$exports), func + "");
}
$d54bc3387ae0143f$exports = $d54bc3387ae0143f$var$baseRest;


var $ff4b2aa90f11886d$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $ff4b2aa90f11886d$var$isIterateeCall(value, index, object) {
    if (!$1f672fed7efed57e$exports(object)) return false;
    var type = typeof index;
    if (type == "number" ? $1dea69b96520dc48$exports(object) && $1360731602f19189$exports(index, object.length) : type == "string" && index in object) return $4848ae3ccf4ff248$exports(object[index], value);
    return false;
}
$ff4b2aa90f11886d$exports = $ff4b2aa90f11886d$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $b5755d2fee0b64bc$var$createAssigner(assigner) {
    return $d54bc3387ae0143f$exports(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && $ff4b2aa90f11886d$exports(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
$b5755d2fee0b64bc$exports = $b5755d2fee0b64bc$var$createAssigner;


/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $71a2f7370c181ea9$var$merge = $b5755d2fee0b64bc$exports(function(object, source, srcIndex) {
    $45d84ad205a796a7$exports(object, source, srcIndex);
});
$71a2f7370c181ea9$exports = $71a2f7370c181ea9$var$merge;


const $e5e6023659c13c1d$var$temperatureGradient = d3.interpolateRgbBasis([
    "#d52304",
    "#ff981e",
    "#fcd288",
    "#fae81e",
    "#69b799",
    "#094a54",
    "#21254d"
]);
const $e5e6023659c13c1d$var$rainfallGradient = d3.interpolateRgbBasis([
    "#1882ff",
    "#49496c"
]);
const $e5e6023659c13c1d$var$formatDate = (date)=>(0, $1232e9c9fcb8c1ea$exports.format)(date, "MM-dd");
const $e5e6023659c13c1d$var$PERTH = {
    lat: -31.9522,
    lon: 115.8614
};
class $e5e6023659c13c1d$var$WeatherData {
    constructor(){
        this._raw = {};
        this._data = null;
        this._ranges = null;
        this._results = null;
        this._lastUpdate = new Date(1960, 0, 1);
    }
    get lastUpdate() {
        return this._lastUpdate;
    }
    get results() {
        return this._results;
    }
    get ranges() {
        return this._ranges;
    }
    loadFromCache() {
        if (localStorage["rawCache"]) {
            this._raw = JSON.parse(localStorage["rawCache"]);
            Object.keys(this._raw).forEach((key)=>{
                const keyDate = new Date(this._raw[key].time);
                this._raw[key].time = keyDate;
                if (keyDate > this._lastUpdate) this._lastUpdate = keyDate;
            });
        }
    }
    async loadData(sourceUrl) {
        console.warn("Load data", sourceUrl);
        const res = await fetch(sourceUrl);
        const rawData = await res.json();
        const parsedRaw = await $e5e6023659c13c1d$var$parseRaw(rawData.daily);
        (0, (/*@__PURE__*/$parcel$interopDefault($71a2f7370c181ea9$exports)))(this._raw, parsedRaw);
    }
    saveToCache() {
        localStorage["rawCache"] = JSON.stringify(this._raw);
    }
    parseResults() {
        const ranges = {};
        const results = {};
        $e5e6023659c13c1d$var$ALL_KEYS.forEach((key)=>ranges[key] = {
                ...$e5e6023659c13c1d$var$minMaxObj
            });
        Object.keys(this._raw).forEach((fullDateKey)=>{
            const dayKey = fullDateKey.substring(5);
            if (!results[dayKey]) {
                results[dayKey] = {
                    ranges: {}
                };
                $e5e6023659c13c1d$var$ALL_KEYS.forEach((key)=>{
                    results[dayKey][key] = [];
                    results[dayKey].ranges[key] = {
                        ...$e5e6023659c13c1d$var$minMaxObj
                    };
                });
            }
            $e5e6023659c13c1d$var$ALL_KEYS.forEach((key)=>{
                const currentVal = this._raw[fullDateKey][key];
                const rangeObj = results[dayKey].ranges[key];
                results[dayKey][key].push(currentVal);
                if (isNaN(rangeObj.maximum) || currentVal > rangeObj.maximum) {
                    rangeObj.maximum = currentVal;
                    if (isNaN(ranges[key].maximum) || currentVal > ranges[key].maximum) ranges[key].maximum = currentVal;
                }
                if (isNaN(rangeObj.minimum) || currentVal < rangeObj.minimum) {
                    rangeObj.minimum = currentVal;
                    if (isNaN(ranges[key].minimum) || currentVal < ranges[key].minimum) ranges[key].minimum = currentVal;
                }
            });
        });
        this._ranges = ranges;
        this._results = results;
    }
}
async function $e5e6023659c13c1d$var$fetchData() {
    const weatherData = new $e5e6023659c13c1d$var$WeatherData();
    weatherData.loadFromCache();
    const daysSinceUpdate = (0, $36df08523e631d65$export$86415ebf4eb36b8c)(new Date(), weatherData.lastUpdate);
    let forecastDaysRequired = 1;
    console.debug("Days since update:", daysSinceUpdate, "forecast days required:", forecastDaysRequired);
    try {
        if (daysSinceUpdate > 7) {
            // Download data since daysSinceUpdate to yesterday
            const startDate = (0, $1232e9c9fcb8c1ea$exports.format)(weatherData.lastUpdate, "yyyy-MM-dd");
            const yesterday = (0, $1232e9c9fcb8c1ea$exports.format)((0, $92e55a48894507f5$export$dd412b56f1e4d8aa)(new Date(), -1), "yyyy-MM-dd");
            await weatherData.loadData(`https://archive-api.open-meteo.com/v1/archive?latitude=${$e5e6023659c13c1d$var$PERTH.lat}&longitude=${$e5e6023659c13c1d$var$PERTH.lon}&start_date=${startDate}&end_date=${yesterday}&daily=temperature_2m_max,temperature_2m_min,rain_sum&wind_speed_unit=kn&timezone=Asia%2FSingapore`);
        } else // < 7 days missing, just fetch forecast
        forecastDaysRequired = daysSinceUpdate;
        if ((0, $4a775c5b3dcbb445$export$5c007e10c6929c95)(weatherData.lastUpdate, (0, $99fc98dcf05ff69b$export$63fa379ae8a9ba2)(new Date()))) {
            console.debug("Last update", weatherData.lastUpdate, "downloading forecast data");
            await weatherData.loadData(`https://api.open-meteo.com/v1/forecast?latitude=${$e5e6023659c13c1d$var$PERTH.lat}&longitude=${$e5e6023659c13c1d$var$PERTH.lon}&daily=temperature_2m_max,temperature_2m_min,rain_sum&past_days=${forecastDaysRequired}&forecast_days=1&timezone=Asia%2FSingapore`);
        } else console.debug("Last update", weatherData.lastUpdate, "NOT downloading forecast data");
        weatherData.parseResults();
        weatherData.saveToCache();
        return weatherData;
    } catch (e) {
        console.error(e);
    }
}
const $e5e6023659c13c1d$var$minMaxObj = {
    minimum: NaN,
    maximum: NaN
};
/**
 * Map multiple arrays back to a single object by name
 * @param data
 * @returns {Promise<void>}
 */ async function $e5e6023659c13c1d$var$parseRaw(dailyData) {
    const ret = {};
    for(let i = 0; i < dailyData.time.length; ++i){
        const dateString = dailyData.time[i];
        const dateValue = new Date(dateString);
        ret[dateString] = {
            time: dateValue,
            [$e5e6023659c13c1d$var$TEMP_MAX_KEY]: dailyData[$e5e6023659c13c1d$var$TEMP_MAX_KEY][i],
            [$e5e6023659c13c1d$var$TEMP_MIN_KEY]: dailyData[$e5e6023659c13c1d$var$TEMP_MIN_KEY][i],
            [$e5e6023659c13c1d$var$RAIN_SUM_KEY]: dailyData[$e5e6023659c13c1d$var$RAIN_SUM_KEY][i]
        };
    }
    return ret;
}
function $e5e6023659c13c1d$var$setCurrentDate(d) {
    $e5e6023659c13c1d$var$currentDate = d;
    $e5e6023659c13c1d$var$currentDay = $e5e6023659c13c1d$var$formatDate($e5e6023659c13c1d$var$currentDate);
    currentDateLarge.innerText = (0, $1232e9c9fcb8c1ea$exports.format)($e5e6023659c13c1d$var$currentDate, "MMMM d");
    sliderDate.value = (0, $bb157686983b9d37$export$d3b42cd8452deec)(d);
    [
        ...document.getElementsByClassName("mouseover-stats")
    ].forEach((el)=>el.classList.add("hidden"));
}
const $e5e6023659c13c1d$var$dailyData = {};
let $e5e6023659c13c1d$var$currentDate;
let $e5e6023659c13c1d$var$currentDay;
$e5e6023659c13c1d$var$setCurrentDate(new Date());
currentDateLarge.classList.remove("loading");
function $e5e6023659c13c1d$var$attachEventHandlers() {
    btnPrevDay.addEventListener("click", ()=>{
        $e5e6023659c13c1d$var$setCurrentDate((0, $92e55a48894507f5$export$dd412b56f1e4d8aa)($e5e6023659c13c1d$var$currentDate, -1));
        return $e5e6023659c13c1d$var$generateCharts();
    });
    btnNextDay.addEventListener("click", ()=>{
        $e5e6023659c13c1d$var$setCurrentDate((0, $92e55a48894507f5$export$dd412b56f1e4d8aa)($e5e6023659c13c1d$var$currentDate, 1));
        return $e5e6023659c13c1d$var$generateCharts();
    });
    btnToday.addEventListener("click", ()=>{
        $e5e6023659c13c1d$var$setCurrentDate(new Date());
        return $e5e6023659c13c1d$var$generateCharts();
    });
    sliderDate.addEventListener("input", (evt)=>{
        $e5e6023659c13c1d$var$setCurrentDate((0, $961776d6230cb8d4$export$2af590ffc7e7d7c5)(new Date(), evt.target.value));
        return $e5e6023659c13c1d$var$generateCharts();
    });
}
let $e5e6023659c13c1d$var$weatherData = null;
async function $e5e6023659c13c1d$var$handleLoad() {
    $e5e6023659c13c1d$var$attachEventHandlers();
    $e5e6023659c13c1d$var$weatherData = await $e5e6023659c13c1d$var$fetchData();
    if (!$e5e6023659c13c1d$var$weatherData) {
        console.error("Something went wrong!");
        return;
    }
    totalRangeStart.classList.remove("loading");
    totalRangeEnd.classList.remove("loading");
    totalRangeStart.innerText = (0, $1232e9c9fcb8c1ea$exports.format)($e5e6023659c13c1d$var$weatherData.ranges.time.minimum, "MMMM d, yyyy");
    totalRangeEnd.innerText = (0, $1232e9c9fcb8c1ea$exports.format)($e5e6023659c13c1d$var$weatherData.ranges.time.maximum, "MMMM d, yyyy");
    return $e5e6023659c13c1d$var$generateCharts();
}
async function $e5e6023659c13c1d$var$generateCharts() {
    return Promise.all([
        $e5e6023659c13c1d$var$generateChart($e5e6023659c13c1d$var$weatherData, $e5e6023659c13c1d$var$TEMP_MAX_KEY, document.getElementById("containerMax"), $e5e6023659c13c1d$var$getTemperatureRange, $e5e6023659c13c1d$var$temperatureGradient, $e5e6023659c13c1d$var$temperatureColor, "\xb0"),
        $e5e6023659c13c1d$var$generateChart($e5e6023659c13c1d$var$weatherData, $e5e6023659c13c1d$var$TEMP_MIN_KEY, document.getElementById("containerMin"), $e5e6023659c13c1d$var$getTemperatureRange, $e5e6023659c13c1d$var$temperatureGradient, $e5e6023659c13c1d$var$temperatureColor, "\xb0"),
        $e5e6023659c13c1d$var$generateChart($e5e6023659c13c1d$var$weatherData, $e5e6023659c13c1d$var$RAIN_SUM_KEY, document.getElementById("containerRain"), $e5e6023659c13c1d$var$getRainfallRange, $e5e6023659c13c1d$var$rainfallGradient, $e5e6023659c13c1d$var$rainfallColor, "mm")
    ]);
}
const $e5e6023659c13c1d$var$width = 1024;
const $e5e6023659c13c1d$var$height = 256;
const $e5e6023659c13c1d$var$marginBottom = 30;
const $e5e6023659c13c1d$var$marginLeft = 0;
const $e5e6023659c13c1d$var$TEMP_MAX_KEY = "temperature_2m_max";
const $e5e6023659c13c1d$var$TEMP_MIN_KEY = "temperature_2m_min";
const $e5e6023659c13c1d$var$RAIN_SUM_KEY = "rain_sum";
const $e5e6023659c13c1d$var$TIME_KEY = "time";
const $e5e6023659c13c1d$var$ALL_KEYS = [
    $e5e6023659c13c1d$var$TEMP_MIN_KEY,
    $e5e6023659c13c1d$var$TEMP_MAX_KEY,
    $e5e6023659c13c1d$var$RAIN_SUM_KEY,
    $e5e6023659c13c1d$var$TIME_KEY
];
const $e5e6023659c13c1d$var$TEMPERATURE_KEYS = [
    $e5e6023659c13c1d$var$TEMP_MIN_KEY,
    $e5e6023659c13c1d$var$TEMP_MAX_KEY
];
function $e5e6023659c13c1d$var$getMinTemperature(ranges) {
    return $e5e6023659c13c1d$var$TEMPERATURE_KEYS.reduce((prev, key)=>Math.min(prev, ranges[key].minimum), Infinity);
}
function $e5e6023659c13c1d$var$getMaxTemperature(ranges) {
    return $e5e6023659c13c1d$var$TEMPERATURE_KEYS.reduce((prev, key)=>Math.max(prev, ranges[key].maximum), -Infinity);
}
function $e5e6023659c13c1d$var$handleTouchDrag(e, mouseover) {
    const { clientX: clientX, clientY: clientY } = e.touches[0];
    const targetElement = document.elementFromPoint(clientX, clientY);
    if (!targetElement) return;
    $e5e6023659c13c1d$var$handleDrag(targetElement, mouseover);
}
function $e5e6023659c13c1d$var$handleMouseDrag(e, mouseover) {
    $e5e6023659c13c1d$var$handleDrag(e.target, mouseover);
}
function $e5e6023659c13c1d$var$handleDrag(targetElement, mouseover) {
    const parentElement = mouseover.parentElement;
    const data = targetElement.dataset;
    if (data.date && data.value) {
        // console.log(e.touches[0]);
        const parentBounds = parentElement.getBoundingClientRect();
        const targetBounds = targetElement.getBoundingClientRect();
        const mouseoverBounds = mouseover.getBoundingClientRect();
        const offsetX = Math.max(0, Math.min(parentBounds.width - mouseoverBounds.width, targetBounds.left - parentBounds.left - mouseoverBounds.width / 2)); // + (targetBounds.width / 2); // - parentBounds.x;
        mouseover.classList.remove("hidden");
        mouseover.style.left = `${offsetX}px`;
        mouseover.innerText = `${(0, $1232e9c9fcb8c1ea$exports.format)(data.date, "yyyy")}: ${data.value}`;
    }
}
function $e5e6023659c13c1d$var$getTemperatureRange(ranges) {
    const ltMaximum = $e5e6023659c13c1d$var$getMaxTemperature(ranges);
    const ltMinimum = $e5e6023659c13c1d$var$getMinTemperature(ranges);
    return [
        ltMinimum,
        ltMaximum
    ];
}
function $e5e6023659c13c1d$var$getRainfallRange(ranges) {
    return [
        ranges[$e5e6023659c13c1d$var$RAIN_SUM_KEY].minimum,
        ranges[$e5e6023659c13c1d$var$RAIN_SUM_KEY].maximum
    ];
}
function $e5e6023659c13c1d$var$temperatureColor(el, colorFn) {
    return colorFn(el[0]);
}
function $e5e6023659c13c1d$var$rainfallColor(el, colorFn) {
    return el[0] <= 0.001 ? "#555555" : colorFn(el[0]);
}
async function $e5e6023659c13c1d$var$generateChart(weatherData, dataKey, target, minMaxFunc, gradient, fillHandler, suffix) {
    const dailyData = weatherData.results[$e5e6023659c13c1d$var$currentDay];
    const ranges = weatherData.ranges;
    const numResults = dailyData.time.length;
    const minDate = new Date(dailyData.time[0]);
    const maxDate = new Date(dailyData.time[numResults - 1]);
    const [stats, graph, mouseover] = [
        ...target.children
    ];
    // Create the SVG container.
    const svg = d3.create("svg").on("touchmove", (e)=>$e5e6023659c13c1d$var$handleTouchDrag(e, mouseover)).on("mousemove", (e)=>$e5e6023659c13c1d$var$handleMouseDrag(e, mouseover)).attr("viewBox", `0 0 ${$e5e6023659c13c1d$var$width} ${$e5e6023659c13c1d$var$height}`).attr("preserveAspectRatio", "xMinYMin meet");
    const [ltMinimum, ltMaximum] = minMaxFunc(ranges);
    const color = d3.scaleSequential([
        ltMaximum,
        ltMinimum
    ], gradient);
    // Special case for Feb 29
    const rangePadding = maxDate.getMonth() === 1 && maxDate.getDate() === 29 ? 4 : 1;
    const x = d3.scaleUtc([
        minDate,
        (0, $6a37a3bc1281828d$export$3d83eec43f4ea476)(maxDate, rangePadding)
    ], [
        $e5e6023659c13c1d$var$marginLeft,
        $e5e6023659c13c1d$var$width
    ]);
    svg.append("g").attr("transform", `translate(0,${$e5e6023659c13c1d$var$height - $e5e6023659c13c1d$var$marginBottom})`).call(d3.axisBottom(x));
    graph.replaceChildren();
    const zipped = d3.zip(dailyData[dataKey], dailyData["time"]);
    const barWidth = Math.floor($e5e6023659c13c1d$var$width / numResults) + 1;
    // Add a rect for each bar.
    svg.append("g").selectAll().data(zipped).join("rect").attr("fill", (d)=>fillHandler(d, color)) //d => color(d[0]))
    .attr("x", (d)=>x(d[1])).attr("y", 0).attr("height", $e5e6023659c13c1d$var$height - $e5e6023659c13c1d$var$marginBottom).attr("width", barWidth).attr("data-value", (d)=>`${d[0]}${suffix}`).attr("data-date", (d)=>d[1]);
    // Append the SVG element.
    graph.append(svg.node());
    stats.innerText = `Highest: ${dailyData.ranges[dataKey].maximum}${suffix}, lowest: ${dailyData.ranges[dataKey].minimum}${suffix}`;
}
async function $e5e6023659c13c1d$var$generateRainfallChart(dailyData, ranges, dataKey, target) {
    const numResults = dailyData.time.length;
    const minDate = new Date(dailyData.time[0]);
    const maxDate = new Date(dailyData.time[numResults - 1]);
    // Create the SVG container.
    const svg = d3.create("svg").on("touchmove", (e)=>$e5e6023659c13c1d$var$handleTouchDrag(e, mouseover)).on("mousemove", (e)=>$e5e6023659c13c1d$var$handleMouseDrag(e, mouseover)).attr("viewBox", `0 0 ${$e5e6023659c13c1d$var$width} ${$e5e6023659c13c1d$var$height}`).attr("preserveAspectRatio", "xMinYMin meet");
    const ltMaximum = ranges[dataKey].maximum;
    const ltMinimum = ranges[dataKey].minimum;
    const color = d3.scaleSequential([
        ltMaximum,
        ltMinimum
    ], $e5e6023659c13c1d$var$rainfallGradient);
    const rangePadding = maxDate.getMonth() === 1 && maxDate.getDate() === 29 ? 4 : 1;
    // BUG: addYears should add 4 years if this is a leap year
    const x = d3.scaleUtc([
        minDate,
        (0, $6a37a3bc1281828d$export$3d83eec43f4ea476)(maxDate, rangePadding)
    ], [
        $e5e6023659c13c1d$var$marginLeft,
        $e5e6023659c13c1d$var$width
    ]);
    svg.append("g").attr("transform", `translate(0,${$e5e6023659c13c1d$var$height - $e5e6023659c13c1d$var$marginBottom})`).call(d3.axisBottom(x));
    const [stats, graph, mouseover] = [
        ...target.children
    ];
    graph.replaceChildren();
    const zipped = d3.zip(dailyData[dataKey], dailyData["time"]);
    // console.debug(zipped);
    const barWidth = Math.floor($e5e6023659c13c1d$var$width / numResults) + 1;
    // Add a rect for each bar.
    svg.append("g").selectAll().data(zipped).join("rect").attr("fill", (d)=>d[0] <= 0.001 ? "#555555" : color(d[0])).attr("x", (d)=>x(d[1])).attr("y", 0).attr("height", $e5e6023659c13c1d$var$height - $e5e6023659c13c1d$var$marginBottom).attr("width", barWidth).attr("data-value", (d)=>d[0]).attr("data-date", (d)=>d[1]);
    // Append the SVG element.
    graph.append(svg.node());
    stats.innerText = `Highest: ${dailyData.ranges[dataKey].maximum}mm, lowest: ${dailyData.ranges[dataKey].minimum}mm`;
}
addEventListener("DOMContentLoaded", $e5e6023659c13c1d$var$handleLoad);


//# sourceMappingURL=index.47afd8a6.js.map
